var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tw-w-full tw-border tw-border-red-700 tw-px-4 tw-py-2 tw-text-lg"},[_vm._v("\n  本製品は日本での取扱いはございません\n")])}
var staticRenderFns = []

export { render, staticRenderFns }